<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    padding = 'md',
    hoverable = false,
    bordered = false,
    clickable = false,
    elevated = false,
    onclick,
    children
  }: {
    padding?: 'none' | 'sm' | 'md' | 'lg';
    hoverable?: boolean;
    bordered?: boolean;
    clickable?: boolean;
    elevated?: boolean;
    onclick?: (event: MouseEvent) => void;
    children?: Snippet;
  } = $props();

  const paddingClasses: Record<string, string> = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  let classes = $derived([
    'card',
    paddingClasses[padding],
    hoverable ? 'card-hoverable' : '',
    bordered ? 'card-bordered' : '',
    elevated ? 'card-elevated' : '',
    clickable ? 'cursor-pointer' : '',
  ].filter(Boolean).join(' '));
  const isInteractive = $derived(clickable || Boolean(onclick));
</script>

{#if isInteractive}
  <div
    class={classes}
    role="button"
    tabindex="0"
    {onclick}
    onkeydown={(e) => e.key === 'Enter' && e.currentTarget.click()}
  >
    {@render children?.()}
  </div>
{:else}
  <div class={classes}>
    {@render children?.()}
  </div>
{/if}
